import api from './client';
import type { User } from '@/types';

interface ApiAuthResponse {
  access_token: string;
  refresh_token: string;
  expires_in: number;
  user: User;
}

export interface AuthResponse {
  accessToken: string;
  refreshToken: string;
  user: User;
}

export async function exchangeFirebaseToken(firebaseToken: string): Promise<AuthResponse> {
  const { data } = await api.post<ApiAuthResponse>('/auth/firebase', {
    firebase_token: firebaseToken,
  });
  return {
    accessToken: data.access_token,
    refreshToken: data.refresh_token,
    user: data.user,
  };
}

export async function refreshAccessToken(refreshToken: string): Promise<{ accessToken: string }> {
  const { data } = await api.post<{ access_token: string }>('/auth/refresh', {
    refresh_token: refreshToken,
  });
  return {
    accessToken: data.access_token,
  };
}
